module.exports = __webpack_public_path__ + "static/media/bg.3914a68b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/bg.jpg
// module id = 239
// module chunks = 0